// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file securities/transactional/datafeed/v1/websocket.proto (package securities.transactional.datafeed.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { PingRequest, PingResponse } from "./ping_pb.js";
import { MarketMoverBatch, MarketMoverWebsocketRequest } from "../../../../financial/order_trade/entity/v1/market_mover_pb.js";
import { RunningTrade, RunningTradeBatch } from "./running_trade_pb.js";
import { Top20 } from "./hotlist_pb.js";
import { Watchlist } from "./watchlist_pb.js";
import { OrderBookBody, OrderBookHeader } from "./orderbook_pb.js";
import { Error } from "./entity_pb.js";
import { Intraday, LivePrice, Orderbook } from "../consumer/entity/v1/entity_pb.js";
import { IEPIEV } from "../../../../financial/company_price_feed/entity/v2/indicative_price_volume_pb.js";
import { BestBidOfferWS } from "../../../../financial/company_price_feed/entity/v1/indicative_price_volume_pb.js";

/**
 * @generated from message securities.transactional.datafeed.v1.WebsocketRequest
 */
export const WebsocketRequest = /*@__PURE__*/ proto3.makeMessageType(
  "securities.transactional.datafeed.v1.WebsocketRequest",
  () => [
    { no: 1, name: "user_id", jsonName: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "channel", kind: "message", T: WebsocketChannel },
    { no: 3, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "ping", kind: "message", T: PingRequest },
  ],
);

/**
 * @generated from message securities.transactional.datafeed.v1.WebsocketChannel
 */
export const WebsocketChannel = /*@__PURE__*/ proto3.makeMessageType(
  "securities.transactional.datafeed.v1.WebsocketChannel",
  () => [
    { no: 1, name: "watchlist", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "order_book", jsonName: "order_book", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "running_trade", jsonName: "running_trade", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "is_hotlist", jsonName: "is_hotlist", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "running_trade_batch", jsonName: "running_trade_batch", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 6, name: "liveprice", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 7, name: "iepiev", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 8, name: "intraday", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 9, name: "best_bid_offer", jsonName: "best_bid_offer", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 10, name: "market_mover", jsonName: "market_mover", kind: "message", T: MarketMoverWebsocketRequest, repeated: true },
  ],
);

/**
 * @generated from message securities.transactional.datafeed.v1.WebsocketWrapMessageChannel
 */
export const WebsocketWrapMessageChannel = /*@__PURE__*/ proto3.makeMessageType(
  "securities.transactional.datafeed.v1.WebsocketWrapMessageChannel",
  () => [
    { no: 1, name: "running_trade", jsonName: "running_trade", kind: "message", T: RunningTrade, oneof: "message_channel" },
    { no: 2, name: "ping", kind: "message", T: PingResponse, oneof: "message_channel" },
    { no: 3, name: "top20", kind: "message", T: Top20, oneof: "message_channel" },
    { no: 4, name: "watchlist", kind: "message", T: Watchlist, oneof: "message_channel" },
    { no: 5, name: "orderbook_header", jsonName: "orderbook_header", kind: "message", T: OrderBookHeader, oneof: "message_channel" },
    { no: 6, name: "orderbook_body", jsonName: "orderbook_body", kind: "message", T: OrderBookBody, oneof: "message_channel" },
    { no: 7, name: "error", kind: "message", T: Error, oneof: "message_channel" },
    { no: 8, name: "running_trade_batch", jsonName: "running_trade_batch", kind: "message", T: RunningTradeBatch, oneof: "message_channel" },
    { no: 9, name: "liveprice", kind: "message", T: LivePrice, oneof: "message_channel" },
    { no: 10, name: "orderbook", kind: "message", T: Orderbook, oneof: "message_channel" },
    { no: 11, name: "iepiev", kind: "message", T: IEPIEV, oneof: "message_channel" },
    { no: 12, name: "intraday", kind: "message", T: Intraday, oneof: "message_channel" },
    { no: 13, name: "best_bid_offer", jsonName: "best_bid_offer", kind: "message", T: BestBidOfferWS, oneof: "message_channel" },
    { no: 14, name: "market_mover_batch", jsonName: "market_mover_batch", kind: "message", T: MarketMoverBatch, oneof: "message_channel" },
  ],
);

